import { API } from '..';
import { FetchPostParams, IPostModel, IPostResponse } from '../../models';

export const fetchPostsApi = (params: FetchPostParams) => {
  return new Promise<IPostResponse>((resolve, reject) => {
    API.post('/v1/post-service/posts/home-post', {
      params,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const fetchPostCategoriesApi = async (): Promise<IPostModel[]> => {
  try {
    const res = await API.get('v1/post-service/postcategories');
    return res.data;
  } catch (error) {
    console.error('Failed to fetch post categories:', error);
    return [];
  }
};

export const fetchPublicPostCategoriesApi = async (): Promise<IPostModel[]> => {
  try {
    const res = await API.get('v1/post-service/public/postcategories');
    return res.data;
  } catch (error) {
    console.error('Failed to fetch post categories:', error);
    return [];
  }
};

// Feed công khai theo danh mục (feature /old — mục "Hoài niệm"). Không cần đăng nhập.
export const fetchPublicPostsByCategory = async (payload: {
  categoryId: string;
  pageNumber: number;
  pageSize: number;
  userId?: string;
  search?: string;
  orderType?: number | null;
}) => {
  const res = await API.post(
    'v1/post-service/public/get-posts-by-category',
    payload
  );
  return res.data as { data: IPostModel[]; pageNumber: number; pageSize: number };
};

export const getAllPost = (data) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.post('v1/post-service/posts/home-post', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const fetchUrlImages = (formData) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.post('v1/media-service/images/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const fetchUrlVideos = (formData) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.post('v1/media-service/video/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const createNewPost = (data) => {
  return new Promise<IPostModel>((resolve, reject) => {
    API.post('v1/post-service/posts', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const createNewPostInGroup = (data) => {
  return new Promise<IPostModel>((resolve, reject) => {
    API.post('/v1/group-service/group/create-new-post-in-group', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const getDetailPost = (param: string) => {
  return new Promise<any>((resolve, reject) => {
    API.get(`v1/post-service/posts/${param}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const editOldPost = (data: string) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.put('v1/post-service/posts', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const sendCommentOfPost = (data) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.post('v1/post-service/comments', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const getAllComment = (data) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.post('v1/post-service/comments/get-comment-by-postId', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const voteUpCountAPost = (data) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.put('v1/post-service/posts/post/up', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const voteDownCountAPost = (data) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.put('v1/post-service/posts/post/down', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const getRelyOfComment = (data) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.post('v1/post-service/comments/get-reply-by-commentId', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const createRelyOfComment = (data) => {
  return new Promise<IPostModel[]>((resolve, reject) => {
    API.post('v1/post-service/comments/reply', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

// Có voiceClipId ⇒ donate kèm lời nhắn giọng nói đã tải lên media-service trước đó.
export interface DonationRequest {
  toUserId: string;
  message: string;
  amount: number;
  isAnonymous: boolean;
  postId?: string;
  voiceClipId?: string;
}

export const donatePost = (data: DonationRequest) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/payment-service/transactions/donation', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
export const donateUser = (data: DonationRequest) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/payment-service/transactions/donation', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const requestFeartureDonate = (data) => {
  return new Promise<any>((resolve, reject) => {
    API.post('/v1/user-service/users/create-donate-receiver-request', data)
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};

export const totalReciveDonate = () => {
  return new Promise<any>((resolve, reject) => {
    API.get('/v1/payment-service/users/donation-history')
      .then((res) => {
        resolve(res.data);
      })
      .catch(reject);
  });
};
